import React from "react";
import "./index.scss";
import { IMdaePopupTitleProps } from "./index";
const MdaePopupTitle: React.FC<IMdaePopupTitleProps> = (props) => {
  const smallPopupTitleClass = props.isSmallPopup
    ? "mdae-small-popup-title-bar"
    : "";
  return (
    <div
      className={
        "row mdae-popup-title-bar " +
        props.className +
        " " +
        smallPopupTitleClass
      }
      style={props.style}
    >
      <div className="col-xs-11 mdae-popup-title-bar-text-container text-overflow-ellipsis">
        <div className={"mdae-popup-title-bar-text text-overflow-ellipsis"}>
          {props.children}
        </div>
        <div className={"col-xs-12 remove-padding"}>
          {props.customTitleRender && <div>{props.customTitleRender()}</div>}
        </div>
      </div>

      {!props.isHideCloseButton && (
        <div
          className="col-xs-1 dx-popup-close-button mdae-popup-title-bar-close-button-container remove-padding sys-mdae-popupt-tile-close-button"
          onClick={props.closePopupHandler}
        >
          <i className="dx-icon-close mdae-popup-title-bar-close-button"></i>
        </div>
      )}
    </div>
  );
};

export { MdaePopupTitle };
